/**
 * @description Component-ScaleLimitForm
 */
import { useChainId } from '@/hooks/web3/useChain';
import './index.less';

import { TRADE_TYPE } from '@/constants/trade';
import { useIsFetchedPairInfo } from '@/features/futures/hooks';
import { useCurrentPairFromUrl, usePairLimitPriceRange } from '@/features/pair/hook';
import { useTradeSide } from '@/features/trade/hooks';
import { useSDK } from '@/features/web3/hook';
import { FC, useMemo } from 'react';
import TradeFormAlert from '../TradeFormAlert';
import TradeFormFooter from '../tradeformFooter';
import PriceInput from './PriceInput';
import ScaleFormDetail from './ScaleFormDetail';
import ScaleLimitPreview from './ScaleLimitPreview';
import ScaleLimitPreviewContent from './ScaleLimitPreview/ScaleLimitPreviewContent';
import ScaleSizeDistribution from './ScaleSizeDistribution';
import ScaleSizeInput from './ScaleSizeInput';

interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
}
const ScaleLimitFormSimple: FC<IPropTypes> = function ({}) {
  const chainId = useChainId();
  const tradeSide = useTradeSide(chainId);
  const currentPair = useCurrentPairFromUrl(chainId);
  const sdkContext = useSDK(chainId);
  const isFetchedPair = useIsFetchedPairInfo(chainId, currentPair?.instrumentAddr, currentPair?.expiry);
  const [lowerPrice, upperPrice] = usePairLimitPriceRange(currentPair, tradeSide);
  const footer = useMemo(() => <TradeFormFooter tradeType={TRADE_TYPE.SCALE_LIMIT} />, []);

  return (
    <div className="syn-scale-limit-form">
      <PriceInput
        currentPair={currentPair}
        sdkContext={sdkContext}
        tradeSide={tradeSide}
        disabled={!isFetchedPair}
        lowerPrice={lowerPrice}
        upperPrice={upperPrice}
      />
      <ScaleSizeInput
        price={currentPair?.fairPrice ? currentPair.wrapAttribute('fairPrice').stringValue : undefined}
        pair={currentPair}
        sdkContext={sdkContext}
      />
      <ScaleSizeDistribution />
      {footer}
      <TradeFormAlert
        chainId={chainId}
        currentPair={currentPair}
        marginToken={currentPair?.rootInstrument.marginToken}
        tradeType={TRADE_TYPE.SCALE_LIMIT}
        tradeSimulation={undefined}
      />
      <ScaleFormDetail tradeSide={tradeSide} currentPair={currentPair} />
      <ScaleLimitPreviewContent />
      <ScaleLimitPreview />
    </div>
  );
};

export default ScaleLimitFormSimple;
